// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {CSSProperties, useMemo, useContext,
  useEffect, useState} from 'react';
import cn from 'classnames';
import zcountry from 'zcountry';
import {Settings_context} from '../../../settings_ctx';
import {Editor} from '../../../../../shared/editor/editor';
import styles from './countries.module.less';
import {use_countries} from '../../../ui/forms/use_countries';
import {Link} from '../../../ui/link';

interface i_countries_props {
  title: string;
  description?: string;
  description_size?: string;
  bg_color?: string;
}

const top_countries = ['AR', 'AU', 'AT', 'BE', 'BR', 'BG', 'CA', 'CL', 'CZ',
  'CO', 'DK', 'FI', 'FR', 'DE', 'GR', 'HK', 'HU', 'IS', 'IN', 'ID', 'IE', 'IL',
  'IT', 'JP', 'MX', 'NL', 'NZ', 'NO', 'PL', 'PT', 'RO', 'RU', 'SG', 'SK',
  'KR', 'ES', 'SE', 'CH', 'TR', 'GB', 'US', 'HR'];

export const Countries = (props: i_countries_props)=>{
  const {title, description, bg_color} = props;
  const {theme} = useContext(Settings_context);
  const {countries} = use_countries('f32', cn(styles.locations_flag_wrap,
    theme.xs, theme.P), styles.locations_flag_icon, null, null, true);
  const s_bg_color = {
    '--features_bg_color': bg_color ? bg_color : '',
  } as CSSProperties;
  const data = useMemo(()=>countries.map(el=>{
    let c_title = el.title;
    if (el.value=='GB')
      c_title = 'United Kingdom';
    return {
      ...el,
      title: c_title,
      c_name: zcountry.code2hiphen_label(el.value),
    };
  }).filter(c=>top_countries.includes(c.value))
    .sort((a, b)=>a.title.localeCompare(b.title)), [countries]);
  const d_size = props?.description_size ? props.description_size : 'u2';
  return <div className={cn(styles.countries_container)} style={s_bg_color}>
    <p className={cn(theme.H2, styles.countries_title)}>{title}</p>
    <p className={cn(theme[d_size], theme.color_n600)}>
      {description}</p>
    <div className={styles.grid}>{data.map((c, i)=><Link key={i}
      to={'https://hola.org/vpn/'+c.c_name}>
      <div key={i} className={styles.countries_wrapper}>
        {c.rendered_item}
        <p className={cn(theme.p3, theme.reg,
          theme.color_n700, styles.country_title)}>
          {c.title}</p>
        </div>
      </Link>)}</div>
    </div>;
};

interface i_countries_editor_props {
  value: i_countries_props;
  on_change: (new_value: i_countries_props)=>void;
  on_cancel: ()=>void;
}

export const Countries_editor = (props: i_countries_editor_props)=>{
  const [state, set_state] = useState<i_countries_props>(()=>({
    title: props.value?.title ?? '',
    bg_color: props.value?.bg_color ?? '',
    description: props.value?.description ?? '',
    description_size: props.value?.description_size ?? 'u2',
  }));
  useEffect(()=>{
      set_state(c=>({...c, ...props.value}));
  }, [props.value]);
  return <Editor
    value={state}
    editors={[{key: 'title', label: 'Title', type: 'text'},
      {key: 'description', label: 'Description', type: 'text'},
      {key: 'description_size', label: 'Description size', type: 'text'},
      {key: 'bg_color', label: 'Background color', type: 'color'}]}
    on_change={v=>set_state(v)}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}>
  </Editor>;
};
